import { render, staticRenderFns } from "./PaymentListPrivateComp.vue?vue&type=template&id=60519ef2&scoped=true"
import script from "./PaymentListPrivateComp.vue?vue&type=script&lang=js"
export * from "./PaymentListPrivateComp.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "60519ef2",
  null
  
)

export default component.exports